import React from 'react'

interface MCCErrorDisplayProps {
  error: string
  isLoading: boolean
  onRetry: () => void
}

const MCCErrorDisplay: React.FC<MCCErrorDisplayProps> = ({
  error,
  isLoading,
  onRetry,
}) => {
  return (
    <div className="p-3 text-center">
      <div className="text-danger mb-2">{error}</div>
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={(e) => {
          e.stopPropagation()
          onRetry()
        }}
        disabled={isLoading}
      >
        {isLoading ? 'Loading...' : 'Retry'}
      </button>
    </div>
  )
}

export default MCCErrorDisplay
